import apiClient from "./client";

function buildHeaders(isFormData, customHeaders = {}) {
  return {
    ...(isFormData
      ? { "Content-Type": "multipart/form-data" }
      : { "Content-Type": "application/json" }),
    Accept: "*/*",
    ...customHeaders,
  };
}

const fetchGetRequest = async (endpoint, params = {}, customHeaders = {}) => {
  const { data: responseData } = await apiClient.get(endpoint, {
    params,
    headers: buildHeaders(false, customHeaders),
  });
  return responseData;
};

const fetchPostRequest = async (
  endpoint,
  data,
  isFormData = false,
  customHeaders = {},
) => {
  const { data: responseData } = await apiClient.post(endpoint, data, {
    headers: buildHeaders(isFormData, customHeaders),
  });
  return responseData;
};

const fetchPutRequest = async (
  endpoint,
  data,
  isFormData = false,
  customHeaders = {},
) => {
  const { data: responseData } = await apiClient.put(endpoint, data, {
    headers: buildHeaders(isFormData, customHeaders),
  });
  return responseData;
};

const fetchPatchRequest = async (
  endpoint,
  data,
  isFormData = false,
  customHeaders = {},
) => {
  const { data: responseData } = await apiClient.patch(endpoint, data, {
    headers: buildHeaders(isFormData, customHeaders),
  });
  return responseData;
};

const fetchDeleteRequest = async (endpoint, customHeaders = {}) => {
  const { data: responseData } = await apiClient.delete(endpoint, {
    headers: buildHeaders(false, customHeaders),
  });
  return responseData;
};

const fetchApi = {
  get: fetchGetRequest,
  post: fetchPostRequest,
  put: fetchPutRequest,
  patch: fetchPatchRequest,
  delete: fetchDeleteRequest,
};

export default fetchApi;
